<template>
    <div class="customer-detail-wx-order">
        <el-row :gutter="20">
            <el-form :inline="true" :model="formInline" class="demo-form-inline select-wrap" size="mini">
                <el-form-item label="下单时间">
                    <el-date-picker
                        v-model="dateRange"
                        type="daterange"
                        align="right"
                        unlink-panels
                        range-separator="至"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期"
                        value-format="yyyy-MM-dd">
                    </el-date-picker>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" size="mini" @click="searchList">查询</el-button>
                </el-form-item>
            </el-form>
        </el-row>
        <el-row :gutter="20">
            <div class="tips">商城原始微信订单，仅用于查询历史微信下单记录；ERP 未同步订单可在此查看。</div>
            <tablePagination :total="totalRecord" :currentPage="formInline.pageCount" :pageSize="formInline.pageSize" @handlePage="handlePage">
            <el-table border :data="orderList" size="mini" v-loading="loading">
                <el-table-column type="index" label="序号" width="60"></el-table-column>
                <el-table-column label="订单号" min-width="220">
                    <template slot-scope="scope">
                        <div class="line-main">
                            主单: {{ scope.row.orderMainNo }}
                            <i style="color: #55a532;cursor: pointer" @click="copyText(scope.row.orderMainNo)" class="el-icon-document-copy"></i>
                        </div>
                        <div class="line-sub" v-if="scope.row.orderNo">
                            子单: {{ scope.row.orderNo }}
                        </div>
                    </template>
                </el-table-column>
                <el-table-column label="订单信息" min-width="150">
                    <template slot-scope="scope">
                        <div>下单: {{ formatDate(scope.row.createTime) || '-' }}</div>
                        <div>状态: {{ scope.row.statusName || '-' }}</div>
                        <div>来源: {{ scope.row.orderSourceName || '-' }}</div>
                    </template>
                </el-table-column>
                <el-table-column label="金额信息" min-width="140">
                    <template slot-scope="scope">
                        <div>订单金额: {{ formatMoney(scope.row.orderAmount) }}</div>
                        <div>微信支付金额: {{ formatMoney(scope.row.wechatAmount) }}</div>
                        <div>余额支付金额: {{ formatMoney(scope.row.balanceAmount) }}</div>
                        <div>优惠券支付金额: {{ formatMoney(scope.row.couponAmount) }}</div>
                    </template>
                </el-table-column>
                <el-table-column label="收货信息" min-width="220">
                    <template slot-scope="scope">
                        <div>{{ scope.row.consigneeName || '-' }} / {{ scope.row.consigneePhone || '-' }}</div>
                        <div>{{ scope.row.consigneeAddress || '-' }}</div>
                    </template>
                </el-table-column>
                <el-table-column label="物流单号" min-width="180">
                    <template slot-scope="scope">
                        <div v-for="(waybill, index) in splitWaybillNo(scope.row.waybillNo)" :key="index" class="line-waybill">
                            {{ waybill }}
                            <i style="color: #55a532;cursor: pointer" @click="copyText(waybill)" class="el-icon-document-copy"></i>
                        </div>
                        <div v-if="splitWaybillNo(scope.row.waybillNo).length === 0">-</div>
                    </template>
                </el-table-column>
                <el-table-column prop="productSummary" label="商品摘要" min-width="240"></el-table-column>
            </el-table>
        </tablePagination>
        </el-row>
    </div>
</template>

<script>
import tablePagination from '@c/tablePagination'

export default {
    data() {
        return {
            loading: false,
            orderList: [],
            totalRecord: 0,
            dateRange: [],
            formInline: {
                customerId: this.$route.params.id,
                start: '',
                end: '',
                pageCount: 1,
                pageSize: 15
            }
        }
    },
    components: {
        tablePagination
    },
    mounted() {
        this.initList()
    },
    methods: {
        syncDateRange() {
            this.formInline.start = this.dateRange && this.dateRange[0] ? this.dateRange[0] : ''
            this.formInline.end = this.dateRange && this.dateRange[1] ? this.dateRange[1] : ''
        },
        initList() {
            this.loading = true
            this.syncDateRange()
            this.$apiGet('lechun-customers/customerMallOrder/getWxOrderList', this.formInline).then(res => {
                this.loading = false
                const list = res.list || (res.value && res.value.list) || (res.data && res.data.list) || []
                const totalRaw = res.total || (res.value && res.value.total) || (res.data && res.data.total)
                const totalNum = typeof totalRaw === 'number' ? totalRaw : parseInt(totalRaw, 10)
                this.orderList = Array.isArray(list) ? list : []
                this.totalRecord = Number.isNaN(totalNum) ? this.orderList.length : totalNum
            }).catch(() => {
                this.loading = false
            })
        },
        searchList() {
            this.formInline.pageCount = 1
            this.initList()
        },
        handlePage(page) {
            this.formInline.pageCount = page
            this.initList()
        },
        copyText(text) {
            var input = document.createElement('textarea')
            input.value = text
            document.body.appendChild(input)
            input.select()
            document.execCommand('Copy')
            document.body.removeChild(input)
            this.$message({
                type: 'success',
                message: '已复制到剪贴板'
            })
        },
        formatDate(datetime) {
            if (!datetime) {
                return ''
            }
            return new Date(datetime).Format('yyyy-MM-dd hh:mm:ss')
        },
        splitWaybillNo(waybillNo) {
            if (!waybillNo) {
                return []
            }
            return String(waybillNo)
                .split(/[/,，、;；\s]+/)
                .map(item => item.trim())
                .filter(item => item && /[0-9A-Za-z]/.test(item))
        },
        formatMoney(value) {
            if (value === null || value === undefined || value === '') {
                return '-'
            }
            return value
        }
    }
}
</script>

<style scoped>
.customer-detail-wx-order{
    width: 100%;
}
.tips{
    margin-bottom: 10px;
    color: #909399;
    font-size: 12px;
}
.line-main{
    font-size: 14px;
    font-weight: 600;
    margin-bottom: 6px;
}
.line-sub{
    font-size: 12px;
    color: #606266;
}
.line-waybill{
    font-size: 12px;
    color: #606266;
    word-break: break-all;
}
</style>
